import * as yup from 'yup';
import { PACKAGE_NAME_MAX_LENGTH } from '../../constants';

export const validationSchema = () =>
  yup.object().shape({
    code: yup.string().required('Обязательное поле'),
    promotion_type: yup.string().default(() => 'bonuses'),
    name: yup.object().shape({
        en: yup
          .string()
          .max(PACKAGE_NAME_MAX_LENGTH, `Максимум ${PACKAGE_NAME_MAX_LENGTH} символов`)
          .required('Обязательное поле'),
        ru: yup
          .string()
          .max(PACKAGE_NAME_MAX_LENGTH, `Максимум ${PACKAGE_NAME_MAX_LENGTH} символов`)
          .required('Обязательное поле'),
        kz: yup
          .string()
          .max(PACKAGE_NAME_MAX_LENGTH, `Максимум ${PACKAGE_NAME_MAX_LENGTH} символов`)
          .required('Обязательное поле')
    }),
    desciption: yup.object().shape({
        en: yup.object(),
        ru: yup.object(),
        kz: yup.object()
    }),
    short_description: yup.object().shape({
        en: yup.string().required('Обязательное поле'),
        ru: yup.string().required('Обязательное поле'),
        kz: yup.string().required('Обязательное поле')
    }),
    banner: yup.object().shape({
        en: yup.string().required('Обязательное поле'),
        ru: yup.string().required('Обязательное поле'),
        kz: yup.string().required('Обязательное поле')
    })
  });
